// Global Instructions Rule Applied!
//
// The per-LP agent drafts switch (UAT follow-ups PR D): one control on the
// LP form's states strip and on the LP Allocation grid. Tri-state on
// accounts.agent_drafts_enabled — Default (the LP status cadence policy
// decides; the resolved outcome is shown in the label), On (draft even where
// the status says signal only; the weekly budget still applies), Off (no
// agent draft of any kind for this LP — signals, brief and memories keep
// flowing). Enforced server-side in agent_drafts__save.
import React from 'react'
import { Segmented, Tooltip } from 'antd'

export type AgentDraftsChoice = 'default' | 'on' | 'off'

export const draftsChoiceFromValue = (value: boolean | null | undefined): AgentDraftsChoice =>
  value === true ? 'on' : value === false ? 'off' : 'default'

export const draftsValueFromChoice = (choice: AgentDraftsChoice): boolean | null =>
  choice === 'on' ? true : choice === 'off' ? false : null

interface AgentDraftsToggleProps {
  value: boolean | null | undefined
  /** What Default resolves to for this LP — 'drafts' or 'signal only' (from
   *  the status cadence policy). Shown inside the Default label. */
  defaultLabel?: string | null
  disabled?: boolean
  onChange: (next: boolean | null) => void
  size?: 'small' | 'middle'
}

export const AgentDraftsToggle: React.FC<AgentDraftsToggleProps> = ({
  value,
  defaultLabel,
  disabled = false,
  onChange,
  size = 'small'
}) => (
  <Tooltip
    title={
      'Agent drafts for this LP. Default follows the LP status cadence policy' +
      (defaultLabel ? ` (${defaultLabel} for this status)` : '') +
      '. On drafts an outreach when a touchpoint is due even where the status says signal only; ' +
      'the weekly drafts budget still applies. Off writes no agent draft of any kind for this LP — ' +
      'signals, the LP brief and memories are unaffected.'
    }
  >
    <Segmented<AgentDraftsChoice>
      size={size}
      disabled={disabled}
      value={draftsChoiceFromValue(value)}
      options={[
        { label: defaultLabel ? `Default (${defaultLabel})` : 'Default', value: 'default' },
        { label: 'On', value: 'on' },
        { label: 'Off', value: 'off' }
      ]}
      onChange={(next) => onChange(draftsValueFromChoice(next as AgentDraftsChoice))}
    />
  </Tooltip>
)
